import { AxiosRequestConfig } from 'axios'
import { apiService } from '../../api-base'
import {
  BlogTagActionResponse,
  BlogTagResponse,
  BlogTagsResponse,
  CreateBlogTagPayload,
} from './types'

export class BlogTagsService {
  static getTags(config?: AxiosRequestConfig) {
    return apiService.get<BlogTagsResponse>('/tags', config)
  }

  static getTagById(id: string, config?: AxiosRequestConfig) {
    return apiService.get<BlogTagResponse>(`/tags/${id}`, config)
  }

  static createTag(data: CreateBlogTagPayload) {
    return apiService.post<BlogTagResponse>('/tags', data)
  }

  static updateTag(id: string, data: CreateBlogTagPayload) {
    return apiService.put<BlogTagResponse>(`/tags/${id}`, data)
  }

  static deleteTag(id: string) {
    return apiService.delete<BlogTagActionResponse>(`/tags/${id}`)
  }
}
